import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(
  ({ className, sideOffset = 6, ...props }, ref) => (
    // Render via Portal so the tooltip escapes any ancestor clipping/stacking
    // context. A trigger nested inside a `backdrop-filter` element (e.g. the
    // frosted toolbar toggle pill holding Code/Preview/Logs) would otherwise
    // have its inline tooltip clipped away in Safari/WebKit — Safari clips
    // descendants of a backdrop-filtered box while Chrome does not, which is
    // why those tips showed in Chrome but not Safari.
    <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        `
        z-50 rounded-md
        bg-white dark:bg-[#1a2036]
        border border-neutral-200 dark:border-white/10
        px-3 py-1.5
        text-sm text-gray-700 dark:text-gray-200
        shadow-lg dark:shadow-black/40
        backdrop-blur-sm
        will-change-[opacity,transform]

        animate-in 
        fade-in-0 
        zoom-in-95

        data-[state=closed]:animate-out 
        data-[state=closed]:fade-out-0 
        data-[state=closed]:zoom-out-95

        data-[side=bottom]:slide-in-from-top-1
        data-[side=top]:slide-in-from-bottom-1
        data-[side=left]:slide-in-from-right-1
        data-[side=right]:slide-in-from-left-1
      `,
        className
      )}
      {...props}
    />
    </TooltipPrimitive.Portal>
  )
)

TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
